.tabs {
    display: flex;

    &:after {
        content: '';
        flex: 1;
        border-bottom-color: 4px solid var(--border-color);
    }

    &.stretch {
        display: flex;

        &:after {
            display: none;
        }
    }

    &.vertical {
        flex-direction: column;

        .tab {
            flex: 1 0 auto !important;
        }
    }
}

.tab {
    line-height: 1.25rem;
    box-sizing: content-box;
    outline: none;
    border: none;
    flex: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    color: inherit;
    user-select: none;
    text-align: center;
    text-decoration: none;
    overflow: hidden;
    position: relative;
    border-bottom: 4px solid var(--border-color);
    padding: var(--tabs-tab-padding);
    /*background: var(--cs-text);*/
    background: var(--tabs-tab-bg);

    &.selected {
        background: var(--tabs-tab-bg);
        color: var(--cs-origin);
        border-bottom-color: var(--cs-origin);
    }

    &.selected.fill-selected {
        background: var(--cs-origin);
        color: var(--cs-text);
        border-bottom-color: var(--cs-origin);
    }

    &.fill {
        background: var(--cs-origin);
        color: var(--cs-text);


        &.selected {
            background: var(--cs-origin);
            color: var(--cs-text);
            border-bottom-color: var(--cs-dark);
        }
    }
}

